import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class StyleSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'style-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
